<template>
  <iframe :src="srcUrl" width="100%" :height="pdfH"></iframe>
</template>

<script>

export default {
  name: 'Pdf',
  props: {
    srcUrl: {
      required: true,
      default: ''
    },
    pdfH: {
      required: false,
      default: 1000
    }
  },
  data(){
    return{
      pdfUrl: ``
    }
  },
  created () {
    this.pdfUrl = `https://test1.sic-credit.com/test/Huangshi/pdf/web/viewer.html?file=${this.srcUrl}`
  }
}
</script>

<style scoped>

</style>